import { createAsyncAction } from '../actions'
import { baseRequest } from '../../core/http_services'
import { showAxiosError, showSuccessMessage } from '../../../web/utils/messenger'

// Fetch bulk invoices
export const { FETCH_EVENT_BULK_INVOICES } = createAsyncAction('FETCH_EVENT_BULK_INVOICES', function (eventId) {
  return dispatch =>
    baseRequest.get(`/event/${eventId}/bulk-invoices`)
      .catch(err => {
        showAxiosError(err)
        throw err
      })
      .then(response => {
        // API response is double-nested: response.data.data.attributes contains the invoices array
        const invoices = response.data.data.attributes || []
        console.log('Fetched invoices:', invoices.length, 'invoices') // Debug log
        dispatch(this.success(invoices))
        return invoices
      })
})

// Fetch single bulk invoice
export const { FETCH_BULK_INVOICE } = createAsyncAction('FETCH_BULK_INVOICE', function (eventId, invoiceId) {
  return async dispatch => {
    try {
      const response = await baseRequest.get(`/event/${eventId}/bulk-invoices/${invoiceId}`)
      const invoiceData = response.data.data?.attributes || response.data.attributes || response.data
      dispatch(this.success(invoiceData))
      return invoiceData
    } catch (err) {
      showAxiosError(err)
      throw err
    }
  }
})

// Create bulk invoice
export const { CREATE_BULK_INVOICE } = createAsyncAction('CREATE_BULK_INVOICE', function (eventId, data) {
  return async dispatch => {
    try {
      const response = await baseRequest.post(`/event/${eventId}/bulk-invoices`, data)
      dispatch(this.success(response.data.data))
      showSuccessMessage('Bulk invoice created successfully')
      return response.data.data
    } catch (err) {
      showAxiosError(err)
      throw err
    }
  }
})

// Update bulk invoice
export const { UPDATE_BULK_INVOICE } = createAsyncAction('UPDATE_BULK_INVOICE', function (eventId, invoiceId, data) {
  return async dispatch => {
    try {
      const response = await baseRequest.put(`/event/${eventId}/bulk-invoices/${invoiceId}`, data)
      dispatch(this.success(response.data.data))
      showSuccessMessage('Bulk invoice updated successfully')
      return response.data.data
    } catch (err) {
      showAxiosError(err)
      throw err
    }
  }
})

// Send bulk invoice
export const { SEND_BULK_INVOICE } = createAsyncAction('SEND_BULK_INVOICE', function (eventId, invoiceId) {
  return async dispatch => {
    try {
      const response = await baseRequest.post(`/event/${eventId}/bulk-invoices/${invoiceId}/send`)
      dispatch(this.success(response.data.data))
      showSuccessMessage('Invoice sent successfully! The customer will receive payment instructions via email.')
      // Refresh the invoice list
      dispatch(FETCH_EVENT_BULK_INVOICES(eventId))
      return response.data.data
    } catch (err) {
      showAxiosError(err)
      throw err
    }
  }
})

// Void bulk invoice
export const { VOID_BULK_INVOICE } = createAsyncAction('VOID_BULK_INVOICE', function (eventId, invoiceId, reason) {
  return async dispatch => {
    try {
      const response = await baseRequest.post(`/event/${eventId}/bulk-invoices/${invoiceId}/void`, { reason })
      const invoiceData = response.data.data?.attributes || response.data.attributes || response.data
      dispatch(this.success(invoiceData))
      showSuccessMessage('Bulk invoice voided successfully')
      // Refresh the invoice list
      dispatch(FETCH_EVENT_BULK_INVOICES(eventId))
      return invoiceData
    } catch (err) {
      showAxiosError(err)
      throw err
    }
  }
})

// Refresh bulk invoice from Stripe
export const { REFRESH_BULK_INVOICE } = createAsyncAction('REFRESH_BULK_INVOICE', function (eventId, invoiceId) {
  return async dispatch => {
    try {
      const response = await baseRequest.post(`/event/${eventId}/bulk-invoices/${invoiceId}/refresh`)
      const invoiceData = response.data.data?.attributes || response.data.attributes || response.data
      dispatch(this.success(invoiceData))
      
      if (invoiceData.status_changed) {
        showSuccessMessage(`Invoice status refreshed: ${invoiceData.old_status} → ${invoiceData.status}`)
      } else {
        showSuccessMessage('Invoice refreshed - no status changes')
      }
      
      // Refresh the invoice list to show updated data
      dispatch(FETCH_EVENT_BULK_INVOICES(eventId))
      return invoiceData
    } catch (err) {
      showAxiosError(err)
      throw err
    }
  }
})

// Create delegation for paid invoice
export const { CREATE_DELEGATION } = createAsyncAction('CREATE_DELEGATION', function (eventId, invoiceId) {
  return async dispatch => {
    try {
      const response = await baseRequest.post(`/event/${eventId}/bulk-invoices/${invoiceId}/create-delegation`)
      const invoiceData = response.data.data?.attributes || response.data.attributes || response.data
      dispatch(this.success(invoiceData))
      showSuccessMessage(`Delegation created successfully for invoice! Delegation ID: ${invoiceData.delegation_id}`)
      
      // Refresh the invoice list to show updated data
      dispatch(FETCH_EVENT_BULK_INVOICES(eventId))
      return invoiceData
    } catch (err) {
      showAxiosError(err)
      throw err
    }
  }
})

// Clear current invoice state (for creating new invoices)
export const CLEAR_CURRENT_INVOICE = 'CLEAR_CURRENT_INVOICE'
export const clearCurrentInvoice = () => ({
  type: CLEAR_CURRENT_INVOICE
})